import {defineStore} from "pinia";
import {computed, ref} from "vue";
import type {TRequisite} from "@/components/profile/RequisiteItem.vue";

export const useModalsStore = defineStore('modals', () => {
    const activeProductId = ref<null | number>(null);
    const isLoginModalShown = ref<boolean>(false);
    const isRequisitesShown = ref<boolean>(false);
    const activeRequisite = ref<null | TRequisite>(null);

    const showRequisitesModal = (): void => {
        isRequisitesShown.value = true
    }

    const setRequisite = (requisite: TRequisite) => {
        activeRequisite.value = requisite
    }

    const getLoginModalStatus = computed(() => {
        return isLoginModalShown.value
    })

    const hideRequisitesModal = (): void => {
        activeRequisite.value = null
        isRequisitesShown.value = false
    }

    const showCommentModal = (productId: number): void => {
        activeProductId.value = productId
    }

    const hideCommentModal = (): void => {
        activeProductId.value = null
    }

    const showLoginModal = (): void => {
        isLoginModalShown.value = true
    }

    const hideLoginModal = (): void => {
        isLoginModalShown.value = false
    }

    return {
        activeProductId,
        hideCommentModal,
        hideLoginModal,
        isLoginModalShown,
        showCommentModal,
        showLoginModal,
        isRequisitesShown,
        showRequisitesModal,
        hideRequisitesModal,
        setRequisite,
        activeRequisite,
        getLoginModalStatus
    }
})